import {
  type MotionValue,
  type SpringOptions,
  useSpring as useFramerSpring,
  useReducedMotion,
} from 'framer-motion';

// framer-motion uses function overloading for useSpring, so we had to create
// two separate functions to maintain type safety

export const useSpringNumber = (
  value: MotionValue<number>,
  options?: SpringOptions
): MotionValue<number> => {
  const prefersReducedMotion = useReducedMotion();
  const springValue = useFramerSpring(value, options);

  return prefersReducedMotion ? value : springValue;
};

export const useSpringString = (
  value: MotionValue<string>,
  options?: SpringOptions
): MotionValue<string> => {
  const prefersReducedMotion = useReducedMotion();
  const springValue = useFramerSpring(value, options);

  return prefersReducedMotion ? value : springValue;
};
